(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
  var select = event.target.closest('.product-card__variant-select');
  if (!select) return;
  var card = select.closest('.product-card');
  var price = card && card.querySelector('.product-card__price');
  var selectedOption = select.options[select.selectedIndex];
  if (price && selectedOption && selectedOption.dataset.price) {
    price.textContent = selectedOption.dataset.price;
  }
});
  } catch(e) { console.error(e); }
})();

})();
